// Typelizer digest f345db10fd35183abf7680e61b0626ea
//
// DO NOT MODIFY: This file was automatically generated by Typelizer.
import type { RouteDefinition, RouteOptions } from '../runtime'
import { buildUrl } from '../runtime'

export default {
  /** GET /showcase */
  new: (options?: RouteOptions): RouteDefinition<'get'> => ({
    url: buildUrl('/showcase', {}, options),
    method: 'get',
  }),

  /** POST /showcase */
  create: (options?: RouteOptions): RouteDefinition<'post'> => ({
    url: buildUrl('/showcase', {}, options),
    method: 'post',
  }),
}
